module.exports = __webpack_public_path__ + "static/media/hands.b2f228c7.png";